module.exports = __webpack_public_path__ + "img/avatar_souless.36c7c36e.png";